import React from 'react';

function CarRegisterManual(props){
  var renderForm=props.renderForm;var renderPreview=props.renderPreview;var emptyPreview=props.emptyPreview;
  var saving=props.saving;var reg=props.reg;var carNo=props.carNo;var vin=props.vin;var owner=props.owner;

  return(<div style={{display:'flex',gap:12,flex:1,overflow:'hidden',width:'100%'}}>
    {/* 왼쪽 25%: 안내 */}
    <div style={{flex:'0 0 25%',display:'flex',alignItems:'center',justifyContent:'center',background:'#f8fafc',borderRadius:12,border:'1px dashed #d0d5dd'}}>
      <div style={{textAlign:'center',color:'#64748b',padding:20}}><div style={{fontSize:36,opacity:0.5}}>✏️</div><div style={{fontSize:14,fontWeight:600,marginTop:8}}>수기 입력 모드</div><div style={{fontSize:12,marginTop:4,color:'#94a3b8'}}>자동차등록증 없이<br/>직접 정보를 입력합니다</div></div>
    </div>
    {/* 가운데 35%: 폼 */}
    <div style={{flex:'0 0 35%',overflowY:'auto'}}>
      {renderForm()}
      <div style={{position:'sticky',bottom:0,background:'#fff',padding:'8px 0'}}>
        <button className="btn btn-green" style={{width:'100%',justifyContent:'center',padding:'12px',fontSize:14}} onClick={function(){reg()}} disabled={saving}>{saving?'⏳':'🚗 차량 등록'}</button>
      </div>
    </div>
    {/* 오른쪽 40%: 미리보기 */}
    <div style={{flex:1,display:'flex',flexDirection:'column',minWidth:0}}>{(carNo||vin||owner)?renderPreview():emptyPreview}</div>
  </div>);
}

export default CarRegisterManual;
